import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import ServiceArea from "@/components/site/ServiceArea";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import SloganBanner from "@/components/site/SloganBanner";

function App() {
  return (
    <div className="App min-h-screen bg-white text-[#1D2B53]" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <SloganBanner />
        <WhyChooseUs />
        <ServiceArea />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
